import Axios from '../axios'
import { ITransaction } from '../../interfaces/i-api-creaditCard'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'
import appConfig from '../../../app.config';

async function getDepositTransactionsService(accountAgreementId: string, accountTransactionDate: string) {
    const response = await Axios
        .get<ITransaction[]>(
            `${appConfig.customerDataBaseUrl}/api/deposit/transactions?accountAgreementId=${accountAgreementId}&accountTransactionDate=${accountTransactionDate}&pageSize=9999999&language=${appConfig.country}`,
            await getHeadersWithJwtToken()
        )
        .then((result) => {
            return result.data as ITransaction[]
        })
        .catch((err) => {
            logError(err)
            if (err.response?.status === 404) {
                return [] as ITransaction[]
            } else {
                throw err
            }
        })
    return response as ITransaction[]
}
export default getDepositTransactionsService;